import { createSlice } from '@reduxjs/toolkit';
import jwtService from 'app/services/jwtService';
import { setUserData, setUserTokenData } from './userSlice';

export const submitUpdateToken = (companyId) => async dispatch => {
	return jwtService
		.updateTokenUser(companyId)
		.then(data => {
			const { userInfo } = data.userInfo;
			if (data.status !== 0) {
				const initialState = userInfo ? {
					role: [], // guest
					data: {
						displayName: userInfo ? userInfo.name : "",
						photoURL: userInfo ? 'assets/images/avatars/profile.jpg' : "",
						email: userInfo ? userInfo.email : "",
						shortcuts: ['calendar', 'mail', 'contacts', 'todo'],
						companyId: userInfo?.companyId,
						exp: userInfo?.exp,
						iat: userInfo?.iat,
						role: userInfo?.role,
						userHash: userInfo?.userHash,
						userId: userInfo?.userId,
						accountType: userInfo?.accountType,
						nameContact: userInfo?.nameContact,
						emailContact: userInfo?.emailContact,
						position: userInfo?.position,
						phoneNumberContact: userInfo?.phoneNumberContact,
						nameCompany: userInfo?.nameCompany,
						identityCompany: userInfo?.identityCompany,
						legalRepresentativeCompany: userInfo?.legalRepresentativeCompany,
						companyRole: userInfo?.companyRole,
						isActor: userInfo?.isActor
					}
				} : {
					role: [], // guest
					data: {
						displayName: "",
						photoURL: "",
						email: "",
						shortcuts: ['calendar', 'mail', 'contacts', 'todo'],
					}
				};


				dispatch(setUserTokenData(initialState));
			}
		})
		.catch(error => {
			console.log(error)
		});
};

export const submitLogin = (email, password) => async dispatch => {
	return jwtService
		.signInWithEmailAndPassword(email, password)
		.then(data => {
			const isValid = data.status !== 0;
			if (isValid) {
				dispatch(setUserData(data.userInfo));
				dispatch(loginSuccess());
				globalThis.location.href = '/';
				return;
			}
			return dispatch(loginError(data.message.message));
		})
		.catch(error_ => {
			return dispatch(loginError(error_));
		});
};


const initialState = {
	success: false,
	errors: []
};

const loginSlice = createSlice({
	name: 'auth/login',  // '/adm/companies',
	initialState,
	reducers: {
		loginSuccess: (state, action) => {
			state.success = true;
			state.errors = [];
		},
		loginError: (state, action) => {
			state.success = false;
			state.errors = action.payload;
		}
	},
});

export const { loginSuccess, loginError } = loginSlice.actions;

export default loginSlice.reducer;
